export default {
  header: {
    home: 'HOME',
    about: 'ABOUT US',
    technology: 'TECHNOLOGY',
    products: 'PRODUCTS',
    services: 'SERVICES',
    contacts: 'CONTACTS',
    oem: 'OEM/ODM',
    rawMaterial: 'Raw Material Customization',
    productCustomization: 'Product Customization',
    importExport: 'Import and Export'
  },
  home: {
    coreBusiness: 'Core Business',
    platform: 'Novel Drug Delivery Platform',
    oneStopPlatform: 'One-Stop Industry Chain Service Platform',
    formulation: 'INNOVATIVE FORMULATION',
    dosageForm: 'Dosage Form',
    dosageForms: {
      oralFilms: 'Oral Films',
      transdermal: 'Transdermal Patches',
      granule: 'Orally Disintegrating Granule'
    },
    application: 'Application',
    applicationText: 'Children, the elderly, patients with special medical condition, pets',
    productStrategy: 'Product Strategy Design',
    productInfo: 'Product Information Database & Project Launch Guidance',
    productRegistration: 'Product Registration Services',
    salesMarket: 'Sales & Market Development',
    supplyDistribution: 'Raw Material Supply & Product Distribution & Customized Services'
  },
  about: {
    companyProfile: 'Company Profile',
    location: 'Seika Pharma, Osaka, Japan',
    businessScopes: 'Business scopes:',
    scope1: 'New production service development',
    scope2: 'FDA registration services',
    scope3: 'Oversea business for cosmetics, health food, pharmaceutical products and excipients',
    scope4: 'Retail and wholesale for pet food, pet supplies, feed additives and pet cares',
    missionVision: 'Mission and Vision'
  },
  footer: {
    exploration: 'EXPLORATION TODAY',
    innovation: 'INNOVATION FOREVER',
    pioneering: 'Pioneering',
    exploring: 'Exploring',
    innovating: 'Innovating',
    surpassing: 'Surpassing',
    subscribeNow: 'SUBSCRIBE NOW',
    subscribe: 'Subscribe',
    contacts: 'CONTACTS',
    email: 'Email：',
    copyright: 'Seikaiyaku.com | Privacy Policy© 2025  All Rights Reserved',
    copyrightMb: 'Copyright©2018-2025 Seikaiyaku.com All Rights Reserved.'
  },
  technology: {
    ddsTitle: 'DDS and Technological Innovation',
    oralFilms: 'Oral Thin Films（OTFs）',
    oralGranules: 'Oral Fast- Dissolving Granules (ODGs)',
    transdermalPatches: 'Transdermal Patches',
    technicalSupport: 'Technical Support',
    productDesign: 'Product design and technical assistance.',
    comprehensiveSolutions: 'Comprehensive industrial solutions.',
    innovativePractice: 'Innovative Practice',
    effectiveFormula: 'Effective formula products in pharmaceuticals, pet medications,',
    petNutrition: 'pet nutrition, and health foods.',
    enhancingConvenience: 'Enhancing convenience and absorption efficiency.',
    purpleBanner: 'Involving pharmaceuticals products, pet medicines, pet nutrition, and health foods.'
  },
  contacts: {
    title: 'Seika Pharma Contacts',
    contactsUs: 'Contacts Us',
    registeredOffice: 'OFFICE',
    addressLabel: 'Address：',
    address: '3F, 1-17-17, Kumata, Higashisumiyoshi Ward, Osaka-shi, Osaka 546-0002 Japan',
    emailLabel: 'Email：',
    sendMessage: 'Send us a Message',
    name: 'Name',
    email: 'Email',
    subject: 'Subject',
    yourMessage: 'Your Message',
    send: 'Send'
  },
  products: {
    title1: 'What is Reduced Coenzyme Q10 (Ubiquinol)?',
    subtitle1: 'Rejuvenate with the Power of Reduced CoQ10 Capsules - Superior Absorption, Maximum Benefits!',
    body1: 'Reduced CoQ10 is a body own substance, and a required nutrient for life in the body\'s natural production of cellular energy (ATP)',
    body2: 'Reduced CoQ10 provides a potent antioxidant protection to cells',
    body3: 'Reduced CoQ10 is the major (99%+) and active form of CoQ10 in the body',
    featuresTitle: 'Product Features',
    feature1Title: 'Reduced CoQ10',
    feature1Text: 'No conversion required, rapid absorption,high bioavailability, 8 times more efficient than oxidized CoQ10',
    feature2Title: 'Premium Ingredients',
    feature2Text: 'Japan\'s top-quality reduced CoQ10,superior product performance',
    feature3Title: 'Scientific Evidence Support',
    feature3Text: '7 key scientific studies support the efficacy',
    detailsTitle: 'Product Details',
    distributionTitle: 'Distribution & Purchase',
    officialStore: 'Official Seika Pharma Store',
    address: 'Address: 〒531-0073 3F 1-17-17 Kumata Higashi-sumiyoshi ku, Osaka, Japan',
    contact: 'Contact:',
    ingredients: 'Ingredients',
    ingredientsTitle: 'Ingredients',
    ingredientsText1: 'Reduced CoQ10',
    ingredientsText2: 'Safflower oil',
    ingredientsText3: 'Glycerin esters of fatty acids',
    ingredientsText4: 'Bees wax',
    specification: 'Specification',
    specificationText1: 'Each softgel contains 100 mg of CoQ10.',
    specificationText2: '30 softgels/bottle',
    suggestedUse: 'Suggested Use',
    suggestedUseText1: 'For health maintenance',
    suggestedUseText2: '1-2 softgels daily with water',
    suggestedUseText3: '',
    shelfLife: 'Shelf Life',
    shelfLifeText1: '24 Months',
    shelfLifeText2: '',
    shelfLifeText3: '',
    targetUsersTitle: 'Target Users',
    targetUsersText1: 'Individuals feeling fatigued',
    targetUsersText2: 'Middle-aged and elderly',
    targetUsersText3: 'Cardiovascular patients',
    targetUsersText4: 'Those with chronic illnesses',
    benefitsTitle: 'Benefits',
    benefitsText1: 'Boosts heart health',
    benefitsText2: 'Combats aging',
    benefitsText3: 'Enhances daily vitality',
    benefitsText4: 'Improves the body\'s ability to synthesize essential substances',
    packageTitle: 'Package & Dosage',
    packageText1: '30 capsules/bottle',
    packageText2: 'Soft capsules',
    packageText3: 'One capsule daily'
  },
  platform: {
    title: 'End-to-End Integrated Production Solutions',
    upstreamLabel: 'Upstream:',
    upstreamValue: 'Raw Materials',
    upstream1: 'Registration Strategy Guidance',
    upstream2: 'Compliance Consulting',
    upstream3: 'Channel Matching',
    midstreamLabel: 'Midstream:',
    midstreamValue: 'Product R&D and Production',
    midstream1: 'Product Design Support',
    midstream2: 'Innovative Formulation Development',
    downstreamLabel: 'Downstream:',
    downstreamValue: 'Sales & Marketing',
    downstream1: 'Sales and Market Development'
  },
  services: {
    rawMaterial: 'Raw Material Customization',
    productCustomization: 'Product Customization',
    importExport: 'Import and Export',
    learnMore: 'Learn more >'
  },
  flow: {
    title: 'Door-to-Door Customize Production Process',
    titleMobile1: 'Door-to-Door Customize',
    titleMobile2: 'Production Process',
    manufactureCoordination: 'Manufacture Coordination',
    oa: 'OA',
    manufacturing: 'Manufacturing',
    packaging: 'Packaging',
    shipping: 'Shipping',
    seikaPharma: 'Seika Pharma',
    tradeCompliance: 'International Trade with Compliance in Import and Export Regulations',
    tradeComplianceMobile1: 'International Trade with Compliance',
    tradeComplianceMobile2: 'in Import and Export Regulations',
    customer: 'Customer',
    exportCertificate: 'Export Quarantine Certificate, Import License',
    specialPackaging: "Special packaging shipping to customer's designated site",
    back: 'back'
  },
  business: {
    title: 'Pharmaceutical Products Import & Export',
    titleMobile1: 'Pharmaceutical Products',
    titleMobile2: 'Import & Export',
    marketResearch: 'Market Research and Analysis',
    regulations: 'Regulations and Compliance',
    productRegistration: 'Product Registration',
    logistics: 'Logistics and Supply Chain Management',
    description: 'Our team is committed to expanding our market reach and crafting innovative sales strategies. We work closely with partners to enhance our pharmaceutical product import and export efforts. By continuously seeking new partnerships, we aim to advance our mission.',
    learnMorePartners: 'Learn About Our Partners'
  },
  popularize: {
    title: 'Product Promotion Strategy',
    subtitle: 'Creating an Integrated Omnichannel Retail Model',
    offlinePromotion: 'Offline Sales Promotion',
    offlineP1: 'Domestic full coverage offline sales team',
    offlineP2: 'Multi-modal offline promotional activities',
    offlineP3: 'Systematic offline sales training system',
    onlinePlatform: 'Online Operation Platform',
    onlineP1: 'Online professional e-commerce operation team',
    onlineP2: 'One-stop digital marketing experience',
    onlineP3: 'New media multi-platform cooperation channels',
    offlineChannels: 'Offline Channels',
    retailPharmacies: 'Retail Pharmacies',
    publicHospitals: 'Public Hospitals',
    medicalCosmetologies: 'Medical Cosmetologies',
    beautySalon: 'Beauty Salon',
    onlineChannels: 'Online Channels',
    ecommerceChannels: 'E-commerce Channels',
    livestreaming: 'Live-streaming Operations Teams'
  },
  material: {
    title: 'Customized Raw Materials ＆ Supply Alignment Services',
    titleMobile1: 'Customized Raw Materials ＆',
    titleMobile2: 'Supply Alignment Services',
    supplyServices: 'Supply Services',
    supplyDescription: 'Facilitating the procurement of raw materials & intermediates, along with import and export services.',
    salesAgencyServices: 'Sales Agency Services',
    salesAgencyDescription: 'Offering raw material sales representation services.',
    apiServices: 'API & Intermediates Supply Service',
    apiDescription: "Possessing robust partnerships and R&D manufacturing capabilities, offerring customized services to meet our clients' needs."
  },
  expansion: {
    title: 'Global Market Expansion',
    marketAnalysis: 'Market Analysis & Strategy',
    globalCompliance: 'Global Compliance & Registration',
    buildingSalesChannels: 'Building Sales Channels',
    elevatingBrand: 'Elevating Brand Presence',
    buildingAlliances: 'Building Strategic Alliances',
    monitoringOptimizing: 'Monitoring & Optimizing'
  },
  coq10: {
    auth: {
      accessDenied: 'Access Denied',
      providePassword: 'Please provide the correct access password',
      enterPassword: 'Enter access password',
      confirm: 'Confirm',
      incorrectPassword: 'Incorrect password, please try again!',
      verificationSuccess: 'Verification successful!'
    },
    hero: {
      brandName: 'PHARMOPTIMA',
      productName: 'Reduced Coenzyme Q10 Capsules',
      capacity: '100mg',
      subtitle: 'Superior Absorption, Maximum Benefits, Revitalize!',
      reducedForm: 'Reduced Form',
      coq10: 'CoQ10'
    },
    info: {
      whatIsTitle: 'What is Reduced Coenzyme Q10?',
      whatIsText1: 'Coenzyme Q10 (CoQ10) is a substance naturally produced in the body, essential for cellular energy (ATP) production, and is also a potent antioxidant.',
      whatIsText2: 'Reduced Coenzyme Q10 is the active form (>95%) of CoQ10 in the body (Wade et al., JAGS 55:1141, 2007). It provides energy, antioxidant protection, and scavenges free radicals, with significant effects on the cardiovascular and nervous systems. It has high bioavailability and can be directly absorbed. As we age, natural CoQ10 levels decline, and reduced CoQ10 levels drop significantly.',
      advantagesTitle: 'Product Advantages',
      adv1Title: 'Reduced Coenzyme Q10',
      adv1Text: 'No conversion required, rapid absorption, high bioavailability, 8 times more efficient than oxidized CoQ10.',
      adv2Title: 'Premium Ingredients',
      adv2Text: 'Using top-quality Japanese reduced CoQ10 raw materials for superior product performance.',
      adv3Title: 'Scientific Evidence Support',
      adv3Text: '7 core journal articles support its efficacy.'
    },
    productInfo: {
      title: 'Product Information',
      targetUsersTitle: 'Target Users',
      targetUsers1: 'Individuals staying up late or easily fatigued',
      targetUsers2: 'Middle-aged and elderly',
      targetUsers3: 'Cardiovascular patients',
      targetUsers4: 'Patients with chronic illnesses',
      scopeTitle: 'Benefits',
      scope1: 'Protect myocardial cells, enhance heart health',
      scope2: 'Anti-aging',
      scope3: 'Boost daily vitality',
      scope4: 'Improve body\'s ability to synthesize essential substances',
      ingredientsTitle: 'Ingredients',
      ingredient1: 'Reduced Coenzyme Q10',
      ingredient2: 'Safflower Seed Oil',
      ingredient3: 'Glycerol Fatty Acid Ester',
      ingredient4: 'Beeswax',
      specTitle: 'Specification, Dosage & Usage',
      spec1: '30 capsules/bottle',
      spec2: 'Soft capsules',
      spec3: 'One capsule daily',
      marketTitle: 'Market/Category & Sales Channel',
      market1: 'Japan / Dietary Supplement',
      market2: 'Cross-border E-commerce'
    },
    purchase: {
      buyNow: 'Buy Now',
      scanCode: 'Scan code to buy',
      contactUs: 'Contact Us'
    }
  },
  registration: {
    title: 'Regulatory Affairs and Products Registration',
    titleMobile1: 'Regulatory Affairs and Products',
    titleMobile2: 'Registration',
    roadMapTitle: 'Registration Services Road Map',
    marketEntryStrategy: 'Market Entry Strategy',
    registrationServices: 'Registration Services in China',
    registrationServicesExplain: 'Involving pharmaceuticals, API, Novel Food Ingredients, and cosmetics',
    endToEndSupport: 'End-to-End Support',
    proposalCreating: 'Proposal Creating',
    technicalSupport: 'Technical Support',
    documentReview: 'Document Review',
    documentDrafting: 'Document Drafting',
    governmentCommunication: 'Government Communication',
    processTracking: 'Process Tracking'
  },
  meta: {
    home: 'SEIKA PHARMA',
    about: 'ABOUT US | SEIKA PHARMA',
    technology: 'TECHNOLOGY | SEIKA PHARMA',
    products: 'PRODUCTS | SEIKA PHARMA',
    contacts: 'CONTACTS | SEIKA PHARMA',
    platform: 'PLATFORM | SEIKA PHARMA',
    services: 'SERVICES | SEIKA PHARMA',
    popularize: 'POPULARIZE | SEIKA PHARMA',
    expansion: 'EXPANSION | SEIKA PHARMA',
    material: 'MATERIAL | SEIKA PHARMA',
    flow: 'FLOW | SEIKA PHARMA',
    business: 'BUSINESS | SEIKA PHARMA',
    registration: 'REGISTRATION | PHARM OPTIMA',
    coq10: 'CoQ10 Product | PHARMOPTIMA',
    oem: 'OEM/ODM | SEIKA PHARMA'
  },
  oem: {
    header: 'Oral Thin Film (OTF)Contract Manufacturing | Pharmaceutical-Grade Process & Quality Control',
    subheader: 'One-Stop OEM / ODM Solutions from Concept to Market',
    bubble1: 'No Water Needed',
    bubble2: 'Instant Dissolution',
    bubble3: 'Accurate Dosage',
    bubble4: 'Portable & Convenient',
    productShowcase: 'Product Showcase',
    applicationAreas: 'Application Areas',
    appBubble1: 'Beauty & Nutrition',
    appBubble2: 'Oral Care & Fresh Breath',
    appBubble3: 'Immune Support & Daily Wellness',
    appBubble4: 'Energy & Focus',
    appBubble5: 'Sleep & Relaxation',
    appBubble6: 'Essential Nutrients',
    equipmentTitle: 'Advanced Equipment & GMP Manufacturing Environment',
    caption1: 'Integrated Coating & Drying Line\nUniform Coating with High-Speed Drying',
    caption2: 'Automated Slitting & Packaging System\nMulti-Spec Production with In-Line Inspection and Automatic Rejection',
    caption3: 'Production Environment\nGMP Grade D Cleanroom Standard',
    footer1: 'Regulatory Compliance',
    footer2: 'Modular Manufacturing Design',
    footer3: 'Smart Manufacturing Workflow',
    footer4: 'High-Precision Process Control',
    footer5: 'Pharmaceutical-Level Quality Assurance'
  }
}
